import React from 'react';

function SpecialEducationPageSession() {
  return (
    <div className="services-details">
      <div className="container">
        <div className="row">
          <div className="col-xl-4 col-lg-5">
            <div className="services-details__sidebar">
              <div className="services-details__services-list">
                <ul className="services-details__services list-unstyled">
                  <li >
                    <a href="/applied-behavioral-analysis">Applied Behavioral Analysis</a>
                  </li>
                  <li>
                    <a href="/speech-language-pathology">Speech Language Pathology</a>
                  </li>
                  <li  >
                    <a href="/occupational-therapy">Occupational Therapy</a>
                  </li>
                  <li className="active">
                    <a href="/special-eduaction">Special Education</a>
                  </li>
                
                </ul>
              </div>
              <div className="banner-one">
                <div 
                  className="banner-one__bg"
                  style={{backgroundImage: "url(assets/images/backgrounds/BG12.png)"}}
                ></div>
                <div className="banner-one__shape-1 float-bob-x">
                  <img src="assets/images/shapes/12.png" alt="" />
                </div>
                <h3 className="banner-one__title">
                Curious how we honor neurodivergent learners?
                  <br /> <b>Let’s talk.</b>
                </h3>
                <div className="banner-one__btn-box">
                  <a href="/contact" className="banner-one__btn thm-btn">Contact Now</a>
                </div>
              </div>
              <div className="sidebar__single sidebar__category">
                <h3 className="sidebar__title">Our role</h3>
                <ul className="sidebar__category-list list-unstyled">
                    <li><a href="javascript:;">Assessment and monitoring</a></li>
                    <li><a href="javascript:;">Collaborative ideas</a></li>
                    <li><a href="javascript:;">Student support</a></li>
                    <li><a href="javascript:;">Inclusive environments</a></li>
                    <li><a href="javascript:;">Parent involvement</a></li>
                </ul>
                </div>
            </div>
          </div>
          <div className="col-xl-8 col-lg-7">
            <div className="services-details__right">
              <div className="services-details__img">
                <img src="assets/images/services/Main8770377.jpg" alt="" />
              </div>
              <h3 className="services-details__title-1">Special Education</h3>
              <p className="services-details__text-1">
              Special education is a tailored approach to teaching students with unique needs and disabilities. It aims to 
              empower students to reach their full potential and to promote academic, social, and emotional growth.
               We collaborate with parents, teachers, and professionals to provide holistic support.</p>
               <p><b>Key Components:</b></p>
             <ul>
                <li>Individualized Education Plans (IEPs): Customized plans outlining specific goals and accommodations.</li>
                <li>Specialized Instruction: Adapted teaching methods and materials to meet individual needs.</li>
                <li>Accommodations and Modifications: Supportive measures to facilitate learning and participation.</li>
                <li>Assistive Technology: Tools and devices to enhance accessibility and independence.</li>
               </ul>
             <br/>
             <div className="services-details__benefit">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="services-details__benefit-img">
                      <img src="assets/images/services/CIRCLE369-369.jpg" alt="" />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="services-details__benefit-content">
                      <h3 className="services-details__benefit-title">Our Approach</h3>
                      <p className="services-details__benefit-text">
                       
                      </p>
                      <ul className="services-details__benefit-points list-unstyled">
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p>Inclusive education</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p>Student-centered planning</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p>Universal Design for Learning (UDL)</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p>Response to Intervention (RTI)</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p>Strengths-based Assessments</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

             <h3 className="services-details__title-3">Pillars that define a Special Educator </h3>
              <ul className="services-details__process list-unstyled">
                <li>
                  <div className="icon">
                    <img src="assets/images/icons/Teacher.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Teacher</h3>
                 </li>
                <li>
                  <div className="icon">
                     <img src="assets/images/icons/Coach.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Coach</h3>
                  </li>
                <li>
                  <div className="icon">
                     <img src="assets/images/icons/Advocate.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Advocate</h3>
                </li>
                <li>
                  <div className="icon">
                     <img src="assets/images/icons/Collaborator.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Collaborator</h3>
                  </li>
                 
              </ul>
            
              
            </div>
          </div>



        

                <div className="services-details__book">
                <div className="services-details__book-img">
                  <img src="assets/images/shapes/277-235.jpg" alt="" />
                </div>
                <div className="services-details__book-shape-1">
                  <img src="assets/images/shapes/services-details-book-shape-1.png" alt="" />
                </div>
                <div className="services-details__book-top">
                  <div className="icon">
                    <span className="icon-phone-call"></span>
                  </div>
                  <div className="content">
                    <p>Have Questions?</p>
                    
                  </div>
                </div>
                <div className="services-details__book-title-and-btn">
                  <h3 className="services-details__book-title">
                  Curious to know more?
                    <br /> We're just a call away — <b>Contact us.</b>
                  </h3>
                  <div className="services-details__book-btn-box">
                    <a href="/contact" className="services-details__book-btn thm-btn">
                      Contact Now
                    </a>
                  </div>
                </div>
              </div>

        </div>
      </div>
    </div>
  );
}

export default SpecialEducationPageSession;